import { PAGE_ASSETS, DEFAULT_APPS_FILTERS } from '../configs/constants';
import {
  FETCH_PAGE_DATA_REQUEST,
  FETCH_PAGE_DATA_SUCCESS,
  FETCH_PAGE_DATA_FAILURE,
  FETCH_APPS_REQUEST,
  FETCH_APPS_SUCCESS,
  FETCH_APPS_FAILURE,
  SET_APPS_FILTERS,
} from '../actions/actionTypes';

const initialState = {
  data: [],
  totals: {},
  totalCount: 0,
  settings: { pending: true, loaded: false, error: false, mode: 'replace' },
  filters: { ...DEFAULT_APPS_FILTERS },
};

const appsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAGE_DATA_REQUEST: {
      if (!action.payload.assets.includes(PAGE_ASSETS.apps)) return state;

      return {
        ...state,
        settings: { ...state.settings, pending: true, error: false, mode: 'replace' },
      };
    }
    case FETCH_PAGE_DATA_SUCCESS: {
      if (!('apps' in action.payload.data)) return state;

      const { items = [], totalCount, totals = {} } = action.payload.data.apps;

      return {
        ...state,
        data: items,
        totals,
        totalCount,
        settings: { pending: false, loaded: true, error: false, mode: 'replace' },
      };
    }
    case FETCH_PAGE_DATA_FAILURE: {
      if (!action.payload.assets.includes(PAGE_ASSETS.apps)) return state;

      return { ...state, settings: { ...state.settings, pending: false, error: true } };
    }
    case FETCH_APPS_REQUEST:
      return {
        ...state,
        settings: {
          ...state.settings,
          pending: true,
          error: false,
          mode: action.payload.mode || 'replace',
        },
      };
    case FETCH_APPS_SUCCESS: {
      const { mode, data, filters = {} } = action.payload;
      const { items = [], totalCount, totals = state.totals } = data;

      return {
        ...state,
        data: mode === 'append' ? [...state.data, ...items] : items,
        totals,
        totalCount,
        filters: { ...state.filters, ...filters },
        settings: { pending: false, loaded: true, error: false, mode },
      };
    }
    case FETCH_APPS_FAILURE:
      return { ...state, settings: { ...state.settings, pending: false, error: true } };
    case SET_APPS_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    default:
      return state;
  }
};

export default appsReducer;
